
































































import { Vue, Component } from 'vue-property-decorator'
import ClockEvents from '@/components/ClockEvents.vue'
import UpcomingShiftList from '@/components/UpcomingShiftList.vue'

@Component({
  metaInfo: {
    title: 'Dashboard',
  },
  components: {
    ClockEvents,
    UpcomingShiftList,
  },
})
export default class Dashboard extends Vue {

  
  // loadingHistory = false

  async mounted() {
    // this.loadClockHistory()
  }


  // get clockHistory() {
  //   return this.$store.getters.clockHistory
  // }

  // get clockHistoryCurrentWeek() {
  //   const nextOffset = this.$store.state.clock.events.historyPaginationOffset + 1
  //   const start = new Date()
  //   const end = new Date()
  //   start.setDate(start.getDate() - nextOffset * 7)
  //   end.setDate(end.getDate() - (nextOffset * 7) + 7)
  //   return `${dayjs(start).format('MMM DD')} - ${dayjs(end).format('MMM DD')}`
  // }

  // async loadClockHistory() {
  //   this.loadingHistory = true
  //   try {
  //     await clock.loadClockHistory(this.$store)
  //   }
  //   finally {
  //     this.loadingHistory = false
  //   }
  // }

}
